<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid grid-prospect gap-32">
        @if(contacto?.nombre) {
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title">
              <div><h4 class="color-gray t-20">Contacto</h4></div>
              <div class="d-grid card-buttons-1 align-self-end">
                <div class="menu-container">
                  <div
                    class="dropdown-container"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      (click)="toggleActionsMenu('menu-' + contacto.contacto_id)"
                      class="btn btn-round-outline"
                    >
                      <img src="assets/svg/tridots.svg" class="center-svg" />
                    </button>
                    <div
                      class="dropdown-menu"
                      [class.show]="openedMenuId === 'menu-' + contacto.contacto_id"
                    >
                      <button
                        class="dropdown-item"
                        (click)="openMdlDeleteContact()"
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="d-grid prospect-name">
                <div><img src="assets/svg/contact-icon.svg" alt="" /></div>
                <div>
                  <h2 class="text-semibold">
                    {{contacto?.nombre}} {{contacto?.apellido}}
                  </h2>
                </div>
              </div>
              <div class="d-flex flex-row gap-20">
                <div class="text-tag color-org text-center">
                  <b>Última actualización:</b> {{contacto?.fecha_actualizacion |
                  date: 'dd/MM/yyyy'}}
                </div>
              </div>
              <div class="d-grid card-buttons-2">
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewCall()">
                    <img class="center-svg" src="assets/svg/call-icon.svg" />
                  </button>
                  <h5>Llamada</h5>
                </div>
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewTask()">
                    <img class="center-svg" src="assets/svg/task-icon.svg" />
                  </button>
                  <h5>Tarea</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openNewEvent()"
                  >
                    <img class="center-svg" src="assets/svg/event-icon.svg" />
                  </button>
                  <h5>Evento</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openSendMail()"
                  >
                    <img class="center-svg" src="assets/svg/mail-icon.svg" />
                  </button>
                  <h5>Correo</h5>
                </div>
              </div>

              <div class="info-card">
                <div class="d-grid info-card-title">
                  <h3>Información de contacto</h3>
                  <div class="d-grid card-buttons-1">
                    <div><img src="assets/svg/edit.svg" alt="" (click)="toggleEdit('info')" /></div>
                    <div class="d-grid">
                      <button class="btn btn-round-outline-mini"(click)="toggleSection('info')" >
                        <img class="center-svg" src="assets/svg/arrow-up.svg" [class.rotated]="!showInfoSection"/>
                      </button>
                    </div>
                      <div *ngIf="editInfo" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('info')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('info')"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail" *ngIf="showInfoSection">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Nombre de la cuenta:</td>
                        <td>
                          @if(contacto.cuenta) {
                          {{contacto.cuenta.nombre_empresa || 'Sin asignar'}} }
                          @else { Sin asignar }
                        </td>
                      </tr>
                      <tr>
                        <td>Propietario del contacto:</td>
                        <td style="vertical-align: middle">
                          @if(contacto.ejecutivo) {
                          <div
                            class="color-org"
                            style="display: flex; align-items: center; gap: 4px"
                          >
                            <button
                              style="
                                background: none;
                                border: none;
                                padding: 0;
                                cursor: pointer;
                              "
                              (click)="openChangeContactModal()"
                            >
                              <img
                                src="assets/svg/change-prospect.svg"
                                width="20px"
                                height="18px"
                                alt="Cambiar contacto"
                              />
                            </button>

                            <u
                              >{{contacto.ejecutivo.nombre}}
                              {{contacto.ejecutivo.apellido}}</u
                            >
                          </div>
                          } @else {
                          <div
                            style="display: flex; align-items: center; gap: 4px"
                          >
                            <span>Sin asignar</span>
                            <button
                              style="
                                background: none;
                                border: none;
                                padding: 0;
                                cursor: pointer;
                                margin-left: 4px;
                              "
                              (click)="openChangeContactModal()"
                            >
                              <img
                                src="assets/svg/change-prospect.svg"
                                width="16"
                                height="16"
                                alt="Asignar contacto"
                              />
                            </button>
                          </div>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>Nombre completo:</td>
                               <td>
                          <ng-container *ngIf="!editInfo; else editNombre">
                            {{ contacto?.nombre }} {{ contacto?.apellido }}
                          </ng-container>
                          <ng-template #editNombre>
                            <div class="d-flex gap-10">
                              <input
                                class="crm-input"
                                type="text"
                                placeholder="Nombre"
                                [(ngModel)]="editableContact.nombre"
                              />
                              <input
                                class="crm-input"
                                type="text"
                                placeholder="Apellido"
                                [(ngModel)]="editableContact.apellido"
                              />
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Cargo:</td>
                         <td>
                          <ng-container *ngIf="!editInfo; else editCargo">
                            {{ contacto?.cargo || '-' }}
                          </ng-container>
                          <ng-template #editCargo>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.cargo"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Correo:</td>
                         <td>
                          <ng-container *ngIf="!editInfo; else editCorreo">
                            <a
                              *ngIf="contacto?.email"
                              href="mailto:{{ contacto.email }}"
                              class="color-org"
                              >{{ contacto.email }}</a
                            >
                            <span *ngIf="!contacto?.email">-</span>
                          </ng-container>
                          <ng-template #editCorreo>
                            <input
                              class="crm-input"
                              type="email"
                              [(ngModel)]="editableContact.email"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Teléfono:</td>
                         <td>
                          <ng-container *ngIf="!editInfo; else editTelefono">
                            {{ contacto?.telefono || '-' }}
                          </ng-container>
                          <ng-template #editTelefono>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.telefono"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Celular:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editCelular">
                            {{ contacto?.celular || '-' }}
                          </ng-container>
                          <ng-template #editCelular>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.celular"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>LinkedIn:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editLinkedin">
                            <a
                              *ngIf="contacto?.linkedin"
                              [href]="contacto.linkedin"
                              target="_blank"
                              class="color-org"
                              >{{ contacto.linkedin }}</a
                            >
                            <span *ngIf="!contacto?.linkedin">-</span>
                          </ng-container>
                          <ng-template #editLinkedin>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.linkedin"
                            />
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Información adicional</h3>
                  <div class="d-grid card-buttons-1">
                    
                    <div><img src="assets/svg/edit.svg" alt="" (click)="toggleEdit('details')" /></div>
                    
                    <div class="d-grid">
                      <button class="btn btn-round-outline-mini" (click)="toggleSection('details')" >
                        <img class="center-svg" src="assets/svg/arrow-up.svg" [class.rotated]="!showDetailsSection" />
                      </button>
                    </div>
                     <div *ngIf="editDetails" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('details')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('details')"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail" *ngIf="showDetailsSection">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Fecha de nacimiento:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editNacimiento"
                          >
                            {{ contacto?.fecha_nacimiento
                              | date: 'dd/MM/yyyy' }}
                          </ng-container>
                          <ng-template #editNacimiento>
                            <input
                              class="crm-input"
                              type="date"
                              [(ngModel)]="editableContact.fecha_nacimiento"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Aniversario empresa:</td>
                         <td>
                          <ng-container
                            *ngIf="!editDetails; else editAniversario"
                          >
                            {{ contacto?.aniversario_empresa
                              | date: 'dd/MM/yyyy' }}
                          </ng-container>
                          <ng-template #editAniversario>
                            <input
                              class="crm-input"
                              type="date"
                              [(ngModel)]="editableContact.aniversario_empresa"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Hobbie:</td>
                       <td>
                          <ng-container *ngIf="!editDetails; else editHobbie">
                            {{ contacto?.hobbie || '-' }}
                          </ng-container>
                          <ng-template #editHobbie>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.hobbie"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Identidad de género:</td>
                         <td>
                          <ng-container
                            *ngIf="!editDetails; else editGenero"
                          >
                            {{ contacto?.identidad_genero || '-' }}
                          </ng-container>
                          <ng-template #editGenero>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.identidad_genero"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Dirección de envío:</td>
                         <td>
                          <ng-container *ngIf="!editDetails; else editEnvio">
                            {{ contacto?.calle_env || '-' }}
                          </ng-container>
                          <ng-template #editEnvio>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableContact.calle_env"
                            />
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Historial registro</h3>
                  <div class="d-grid card-buttons-1">
                    <div class="d-grid">
                      <button class="btn btn-round-outline-mini" (click)="toggleSection('history')">
                        <img class="center-svg" src="assets/svg/arrow-up.svg" [class.rotated]="!showHistorySection"/>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail" *ngIf="showHistorySection">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Creado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u
                              >{{contacto.creadoPor?.nombre || 'Sistema'}}
                              {{contacto.creadoPor?.apellido}}</u
                            >
                          </div>
                        </td>
                        <td>
                          {{contacto?.fecha_creacion | date: 'dd/MM/yyyy
                          HH:mm'}}
                        </td>
                      </tr>
                      <tr>
                        <td>Modificado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u
                              >{{contacto.actualizadoPor?.nombre || 'Sistema'}}
                              {{contacto.actualizadoPor?.apellido}}</u
                            >
                          </div>
                        </td>
                        <td>
                          {{contacto?.fecha_actualizacion | date: 'dd/MM/yyyy
                          HH:mm'}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-container white-bg">
          <app-nav-account [contacto]="contacto"></app-nav-account>
        </div>
        } @else {
        <div class="no-contact-message">
          <p>No se encontró información del contacto</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
